import React from 'react'
import { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';


// ✅ Reusable Component (moved outside)
const PartnerTop = (props) => {

    const [isSubmitted, setIsSubmitted] = useState(false);


    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();
        setIsSubmitted(true); // disable the button immediately

        emailjs
            .sendForm('service_yalh5wy', 'template_6fiq0l4', form.current, {
                publicKey: '_IokqDxhynHK8phwD',
            })
            .then(
                () => {
                    alert('Submitted successfully!');
                    form.current.reset();         // Optional: clear form fields
                    setIsSubmitted(true);         // Keep button disabled
                },
                (error) => {
                    console.log('FAILED...', error.text);
                    setIsSubmitted(false);        // Re-enable button on failure
                }
            );
    };


    return (
        <section className="py-5 text-start" style={{ backgroundColor: 'rgb(4,180,228' }}>
            <div className="container">
                <div className="row align-items-center">
                    {/* Left Text Section */}
                    <div className="col-md-6 text-white mb-4 mb-md-0">
                        <h1 className="fw-bold display-4">{props.largeHeading}</h1>
                        <p className="fs-4 mt-3">{props.smallHeading}</p>
                        <button className="btn btn-light mt-4 px-4 py-2 fw-semibold" data-bs-toggle="modal"
                            data-bs-target="#getInTouchModal2">
                            {props.btnText || "Start your journey today!"}
                        </button>
                    </div>

                    {/* Right Image Section */}
                    <div className="col-md-6 text-center">
                        <img
                            src={props.image}
                            alt="Partner Illustration"
                            className="img-fluid"
                            style={{ maxHeight: '350px' }}
                        />
                    </div>
                </div>
            </div>

            <div
                className="modal fade"
                id="getInTouchModal2"
                tabIndex="-1"
                aria-labelledby="getInTouchModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content border-0 shadow-lg rounded-4" style={{ overflow: "hidden" }}>
                        <div className="modal-header bg-white border-0 pt-4 px-4 pb-2">
                            <h5
                                className="modal-title fw-bold"
                                id="getInTouchModalLabel"
                                style={{ color: "rgb(4,180,228)", fontSize: "2.2rem" }}
                            >
                                Let's Start
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                style={{ fontSize: "1.2rem" }}
                            ></button>
                        </div>

                        <hr style={{
                            borderTop: "2px solid rgb(4,180,228)",
                            opacity: "1",
                            margin: "0 1.5rem"
                        }} />

                        <div className="modal-body bg-white px-4 pb-4 pt-3 text-start">
                            <form ref={form} onSubmit={sendEmail}>
                                <div className="row g-4 mb-3">
                                    <div className="col-md-6">
                                        <label className="form-label text-dark fw-semibold" style={{ fontSize: "1.1rem" }}>
                                            Name
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control border border-2 rounded-3 py-3 px-3"
                                            placeholder="Enter your name"
                                            name='name'
                                            style={{ fontSize: "1.1rem" }}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label text-dark fw-semibold" style={{ fontSize: "1.1rem" }}>
                                            Email
                                        </label>
                                        <input
                                            type="email"
                                            className="form-control border border-2 rounded-3 py-3 px-3"
                                            placeholder="Enter your email address"
                                            name='Email'
                                            style={{ fontSize: "1.1rem" }}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <label className="form-label text-dark fw-semibold" style={{ fontSize: "1.1rem" }}>
                                        Mobile Number
                                    </label>
                                    <input
                                        type="tel"
                                        className="form-control border border-2 rounded-3 py-3 px-3"
                                        placeholder="Enter your mobile number"
                                        name='phone'
                                        style={{ fontSize: "1.1rem" }}
                                        required
                                    />
                                </div>

                                <div className="mb-4">
                                    <label className="form-label text-dark fw-semibold" style={{ fontSize: "1.1rem" }}>
                                        Select Product
                                    </label>
                                    <select
                                        className="form-select border border-2 rounded-3 py-3 px-3"
                                        style={{ fontSize: "1.1rem" }}
                                        name="interested_in"
                                        required
                                    >
                                        <option value="">Select a product</option>
                                        <option value="School Management System">School Management System</option>
                                        <option value="Institute Management System">Institute Management System</option>
                                        <option value="Learning Management System">Learning Management System</option>
                                        <option value="Website Development">Website Development</option>
                                    </select>
                                </div>

                                <div className="text-center mt-4">
                                    <button
                                        type="submit"
                                        disabled={isSubmitted}
                                        className="btn text-white px-5 py-3 fw-semibold"
                                        style={{
                                            backgroundColor: isSubmitted ? '#ccc' : 'rgb(4,180,228)',
                                            borderRadius: '12px',
                                            fontSize: '1.1rem',
                                            transition: 'all 0.3s ease',
                                            width: '100%',
                                            maxWidth: '300px',
                                            cursor: isSubmitted ? 'not-allowed' : 'pointer'
                                        }}
                                        onMouseOver={(e) => {
                                            if (!isSubmitted) e.target.style.backgroundColor = '#00a8d4';
                                        }}
                                        onMouseOut={(e) => {
                                            if (!isSubmitted) e.target.style.backgroundColor = 'rgb(4,180,228)';
                                        }}
                                    >
                                        {isSubmitted ? "Submitted" : "Submit"}
                                    </button>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </section>
    );
};

export default PartnerTop
